import React, { useCallback, useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/inputs/TextField';
import { LanguageSelector } from './style';

function MultiLanguageTextField({
  id,
  InputProps = {},
  language,
  value = {},
  onChange,
  onAddSync,
  ...rest
}) {
  const [lang, setLang] = useState(language);

  const memoValue = useMemo(() => (value && typeof value === 'object' ? value[lang] : ''), [
    lang,
    value
  ]);

  // Initialize value if empty
  useEffect(() => {
    if (!value && onAddSync) {
      onAddSync(id, { de: '', en: '' });
    }
  }, [id, onAddSync, value]);

  const handleChange = useCallback(
    event => onChange({ ...(value || {}), [lang]: event.target.value }),
    [lang, value, onChange]
  );

  const handleLanguageChange = useCallback(
    newLang => {
      setLang(newLang);

      if (value) {
        onChange({ ...(value || {}), multiLangFieldActiveLang: newLang });
      } else {
        onChange({ de: '', en: '', multiLangFieldActiveLang: newLang });
      }
    },
    [onChange, value]
  );

  return (
    <TextField
      {...rest}
      value={memoValue}
      onChange={handleChange}
      InputProps={{
        ...InputProps,
        // Only pass React-safe props to TextField; handle custom logic here
        endAdornment: <LanguageSelector selectedLanguage={lang} onChange={handleLanguageChange} />
      }}
    />
  );
}

MultiLanguageTextField.propTypes = {
  id: PropTypes.string,
  InputProps: PropTypes.object,
  language: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  onAddSync: PropTypes.func
};

export default React.memo(MultiLanguageTextField);
